import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  HostBinding,
  OnInit,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Product } from '../../../models/product';
import { ProductApiService } from '../../../services/apis/product-api.service';
import { ProductListItem } from '../product-list-item/product-list-item';

@Component({
  selector: 'app-recently-viewed-product-list',
  imports: [ProductListItem, MatIconModule],
  templateUrl: './recently-viewed-product-list.html',
  styleUrl: './recently-viewed-product-list.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RecentlyViewedProductList implements OnInit {
  products: Product[] = [];
  constructor(private productApi: ProductApiService) {}

  @HostBinding('class.no-recently-viewed')
  get noRecentlyViewed() {
    return this.products.length === 0;
  }

  ngOnInit(): void {
    this.findRecentlyViewedProducts();
  }

  loading: boolean = false;
  async findRecentlyViewedProducts() {
    try {
      this.loading = true;
      this.products = await this.productApi.findRecentlyViewedProducts({
        limit: 10,
      });
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
